var _g, _g2, _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChannelsPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 60,
    viewBox: "0 0 84 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3096_140780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.06829 22.8641C1.76269 21.7235 1.92267 20.5083 2.51305 19.4858C3.10343 18.4632 4.07583 17.717 5.21636 17.4114L33.3119 9.88327C34.4524 9.57767 35.6676 9.73765 36.6902 10.328C37.7128 10.9184 38.4589 11.8908 38.7645 13.0313L46.2927 41.1269C46.5983 42.2674 46.4383 43.4826 45.8479 44.5052C45.2576 45.5277 44.2852 46.2739 43.1446 46.5795L15.0491 54.1077C13.9086 54.4133 12.6934 54.2533 11.6708 53.6629C10.6482 53.0725 9.90207 52.1001 9.59647 50.9596L2.06829 22.8641Z",
    fill: "#AE9AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1399 23.8682L18.1422 23.8676C19.0148 23.6238 19.898 23.3905 20.7706 23.16C21.202 23.046 21.6308 22.9327 22.0545 22.8192C22.4515 22.7128 22.8524 22.6039 23.2557 22.4943C24.1539 22.2502 25.0643 22.0027 25.9715 21.773L25.9715 21.773C29.9507 20.7654 34.3014 23.2598 35.4943 27.1847L35.495 27.1872C36.7602 31.3818 34.5552 35.9418 30.2773 37.22C27.4675 38.0611 24.5729 38.9191 21.5961 39.478C21.3681 39.8941 21.1289 40.3056 20.8991 40.7008C20.827 40.8248 20.7558 40.9473 20.6862 41.0677L20.6851 41.0695C20.5136 41.3653 20.2517 41.7115 19.8481 41.9577C19.4147 42.2221 18.9159 42.311 18.4047 42.2285L18.4044 42.2285C17.9584 42.1564 17.5294 41.9669 17.1828 41.6223C16.8458 41.2872 16.6639 40.8824 16.5677 40.5033L16.567 40.5006C16.4656 40.0974 16.3569 39.6936 16.245 39.2793L16.2255 39.2072C16.1321 38.8617 16.0367 38.5084 15.9448 38.1527C14.0376 36.8043 12.8643 34.9461 12.5358 32.5626L12.5358 32.5625C12.0168 28.7927 14.4471 24.9077 18.1399 23.8682Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3644 30.4895C19.5503 30.4346 19.7452 30.4173 19.9379 30.4385C20.1305 30.4598 20.3169 30.5192 20.4863 30.6133C20.6556 30.7074 20.8045 30.8342 20.9241 30.9865C21.0437 31.1388 21.1318 31.3133 21.1831 31.5C21.2924 31.8899 21.2425 32.3073 21.0441 32.6606C20.8458 33.014 20.5152 33.2743 20.1251 33.3845C19.3879 33.5621 18.4901 33.0288 18.2985 32.3012C18.2097 31.9205 18.2708 31.52 18.4692 31.1828C18.6675 30.8456 18.988 30.5974 19.3644 30.4895Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0304 29.198C24.2163 29.1431 24.4112 29.1258 24.6039 29.147C24.7965 29.1683 24.983 29.2277 25.1523 29.3218C25.3216 29.4159 25.4705 29.5427 25.5901 29.695C25.7098 29.8473 25.7978 30.0218 25.8491 30.2085C25.9585 30.5984 25.9085 31.0158 25.7101 31.3691C25.5118 31.7225 25.1812 31.9828 24.7911 32.093C24.0539 32.2706 23.1562 31.7373 22.9645 31.0097C22.8757 30.629 22.9368 30.2285 23.1352 29.8913C23.3336 29.5541 23.6541 29.3059 24.0304 29.198Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6944 27.9066C28.8803 27.8517 29.0753 27.8344 29.2679 27.8556C29.4606 27.8769 29.647 27.9363 29.8164 28.0304C29.9857 28.1245 30.1345 28.2514 30.2542 28.4036C30.3738 28.5559 30.4619 28.7305 30.5132 28.9171C30.6225 29.307 30.5725 29.7245 30.3742 30.0778C30.1758 30.4311 29.8453 30.6914 29.4552 30.8017C28.7179 30.9792 27.8202 30.4459 27.6286 29.7184C27.5398 29.3376 27.6009 28.9372 27.7992 28.5999C27.9976 28.2627 28.3181 28.0145 28.6944 27.9066Z",
    fill: "#222222"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_3096_140780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9556 6.85558C45.546 5.83302 46.5184 5.08686 47.6589 4.78126C48.7994 4.47566 50.0147 4.63564 51.0372 5.22602L76.227 19.7693C77.2496 20.3597 77.9957 21.3321 78.3013 22.4727C78.6069 23.6132 78.4469 24.8284 77.8566 25.8509L63.3132 51.0407C62.7229 52.0633 61.7504 52.8094 60.6099 53.1151C59.4694 53.4207 58.2542 53.2607 57.2316 52.6703L32.0419 38.127C31.0193 37.5366 30.2731 36.5642 29.9675 35.4237C29.6619 34.2831 29.8219 33.0679 30.4123 32.0454L44.9556 6.85558Z",
    fill: "#C4B6FF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.0821,
    cy: 28.9232,
    r: 10,
    transform: "rotate(30 54.0821 28.9232)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0821 20.2629C54.3017 17.5029 48.1819 19.1427 45.4219 23.9232C42.6619 28.7037 44.3017 34.8234 49.0821 37.5834C53.8626 40.3434 59.9824 38.7037 62.7424 33.9232C65.5024 29.1427 63.8626 23.0229 59.0821 20.2629ZM49.2511 35.2908C46.0753 32.8914 45.1139 28.4566 47.1539 24.9232C47.4639 24.3863 47.8282 23.9153 48.2308 23.478L49.9841 30.0213L49.4841 30.8873C48.9341 31.8399 49.2635 33.0693 50.2161 33.6193L49.2511 35.2908ZM56.4959 36.541C56.6758 35.7095 56.3249 34.8372 55.5455 34.3872L54.6794 33.8872L56.1794 31.2891C56.4544 30.8128 56.2897 30.1981 55.8134 29.9231L50.6173 26.9231L51.6173 25.1911L53.3493 26.1911C53.8256 26.4661 54.4403 26.3013 54.7153 25.825L55.7153 24.093L57.4474 25.093C58.4 25.643 59.6294 25.3136 60.1794 24.3609L60.3844 24.0059C62.3269 26.5014 62.6846 30.0219 61.0096 32.9231C59.9696 34.7244 58.3317 35.9612 56.4959 36.541Z",
    fill: "#222222"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_3096_140780",
    x: 24.8164,
    y: 0.629517,
    width: 58.6367,
    height: 58.6372,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0068 0 0 0 0 0.0102133 0 0 0 0 0.0132 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3096_140780"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0068 0 0 0 0 0.0102133 0 0 0 0 0.0132 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3096_140780",
    result: "effect2_dropShadow_3096_140780"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0068 0 0 0 0 0.0102133 0 0 0 0 0.0132 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_3096_140780",
    result: "effect3_dropShadow_3096_140780"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_3096_140780",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3096_140780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.9907,
    height: 37.9907,
    fill: "white",
    transform: "translate(0.916016 18.5637) rotate(-15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelsPlaceholder);
export default __webpack_public_path__ + "static/media/channels-placeholder.2aa6ec8d36fd969af91027885ac5a7d0.svg";
export { ForwardRef as ReactComponent };